import styled from "styled-components";
import bg from "../../assets/images/bg_search_page.gif";

export const Align = styled.div`
    text-align: center;
`;

export const Top = styled.div`
    height: 50%;
    width: 100%;
    position: fixed;
    z-index: 1;
    overflow-x: hidden;
    padding-top: 20px;
    top: 0;
    background: url(${bg});
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`;

export const Bottom = styled.div`
    height: 50%;
    width: 100%;
    position: fixed;
    z-index: 1;
    overflow-x: hidden;
    padding-top: 20px;
    bottom: 0;
    background-color: #ecf1f8;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
`;
